module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/id_3-9e6213f87836b5c3da0fc6ecc5b7152a.jpg";